module.exports = __webpack_public_path__ + "img/padel-pala-pelotas-azul.2db67d68.jpg";